 
import consent from '../components/consent/consent.vue';
import Kirbyimage from '../components/kirbyimage.vue' 
	export default {
	components: { Kirbyimage, consent },
		scrollToTop: true,
		layout: 'default',
		transition: 'fade', 
		data()
		{
			return{ 
				head: {}, 
				page: {},
				subpages: {},
				openAccordian: null,
				loaded: false
			}
		},  
		mounted(){
			this.$store.commit('global/setShowBookDemoState', this.page.showBookDemo)
		},
		computed:{
			podcast_embed(){
				if (this.page.podcastSpotifyLink){
					return this.page.podcastSpotifyLink
					.replace(".com/show/", ".com/embed/show/")
					.replace(".com/episode/", ".com/embed/episode/");
				} else {
					return false;
				}
			},
			normaliseUrl()
			{ 

				if (!this.page.website)
					return '';
				
				let url = this.page.website.replace("https://", "").replace("www.", "");
				let parts = url.split('?');

				return parts[0];
  
			}
		},
		head() {

			return this.head;
			
		}, 
		async fetch() {
			
			let self = this;
 
			const path = this.$route.path == '/' ? 'home' : this.$route.path.substring(1);
		 
			let page = null;
 			
			let index = this.$store.state.directory.findIndex((item) => item.key ==  path);
 
			page = this.$store.state.directory[index];

			if ((process.server || page != null) && this.$store.state.directory)
			{

				if (page != null)
				{
				 
					this.$store.commit('page/setPageContent', page);    
					this.head = page.head; 
					this.page = page;
					this.subpages = page.subpages

					this.loaded = true;
				}
				else
				{
					console.log("server page is null", page == null);
 
					//this.$nuxt.error({ statusCode: 404, message: 'Page not found' });
				}
				
			}
			else if (page == null)
			{ 
                await self.$axios.$post('https://future-plus.co.uk/.netlify/functions/content',
                    {
						query: "page('" + path + "')",
						select: { 
							parent_title: "page.parent.title",
							author: "page.author",
							published: "page.published",
							title: "page.title",
							head: "page.title.toSeoHelper", 
							blocks: "page.blocks.toBlocksHelper",  
							template: "page.intendedTemplate", 
							listing  : "page.blocks.toListingHelper",  
							tagTypes: "page.tags_type",
							tagTopics: "page.tags_topic",
							podcastSpotifyLink: "page.podcastSpotifyLink",
							podcastAppleLink: "page.podcastAppleLink",
							podcastGoogleLink: "page.podcastGoogleLink",
							podcastAmazonLink: "page.podcastAmazonLink",
        					podcastEmbedType: "page.podcastEmbedType",
							logo: "page.logo.toFilesHelper",
							description: "page.description",
							report: "page.report.toFilesHelper",
							embed: "page.embed",
							website: "page.website",
							showBookDemo: "page.showBookDemo",
							siblings:{
								query : "page.siblings",
								select: { 
									page : "page.title",
									template: "page.intendedTemplate", 
                     				listing  : "page.blocks.toListingHelper"
								}
							},
							subpages : {
							query : "page.children",
								select: {
									title : "page.title",
									template: "page.intendedTemplate", 
									resourceSummary: "page.resourceSummary",
									published: "page.published.toPrettyDate()",
									tagTypes: "page.tags_type",
									tagTopics: "page.tags_topic"
								}
							}   
					}
				   }, {
                        baseURL: "",
                        auth: "",                                
                        headers: {
                            common: {
                            Authorization: ''
                            }
                        },
                        config: {
                            auth: ""
                        }
                    }
                ).then(resp => {
 
				 	page = resp.data.result;

					console.log("then resp",resp);

					if (page != null)
					{
					
						this.$store.commit('page/setPageContent', page);   
						this.head = page.head;
						this.blocks = page.blocks;
						this.page = page;
						this.subpages = page.subpages
 

						this.loaded = true;
					}
					else
					{
						console.log("page is null", page == null);
						this.$nuxt.error({ statusCode: 404, message: 'Page not found' });
 
					}

				}).catch(function (error) {
					
					if (error.response) {
					// Request made and server responded
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
					} else if (error.request) {
					// The request was made but no response was received
					console.log(error.message);
					} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					} 

					
					if (path != 'search')
					{
			 			return self.$nuxt.error({ statusCode: 404, message: error.message })
					}
				});

 
			}

				
		}

		
	}

